import { getActiveOrganization, useActiveOrganization } from './useActiveOrganization'

/** Is (currently active) auction admin only */
export const useIsAuctionAdmin = (...props: Parameters<typeof useActiveOrganization>) => {
    const activeOrg = useActiveOrganization(...props)
    const isAuctionAdmin = activeOrg?.isAdmin || false
    return isAuctionAdmin
}

/** Is (currently active) auction admin only */
export const getIsAuctionAdmin = async (...props: Parameters<typeof getActiveOrganization>) => {
    const activeOrg = await getActiveOrganization(...props)
    const isAuctionAdmin = activeOrg?.isAdmin || false
    return isAuctionAdmin
}
